import axios from 'axios';
import { logger } from '@fiverr-private/perseus';
import { getContext } from '@fiverr-private/fiverr_context';

export const getFormData = async({ pathfinderWrapper }) => {
    const { pathParameters } = getContext();
    const { username, slug } = pathParameters;

    const url = pathfinderWrapper.pathfinder('new_custom_order_request_form', { seller: username, gig: slug });

    try {
        const { data } = await axios.get(url);
        return data;
    } catch (err) {
        const error = new Error('Failed to fetch custom order data');
        logger.error(
            error,
            {
                responseStatus: err.response.status,
                ajaxUrl: url
            }
        );

        throw error;
    }
};
